import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CloudSun03 = function CloudSun03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M3.15 11A7.54 7.54 0 0 1 3 9.5C3 5.3579 6.3579 2 10.5 2c3.8031 0 6.945 2.8306 7.4339 6.5M6 22c-2.2091 0-4-1.7909-4-4s1.7909-4 4-4q.17 0 .3365.014C7.1562 11.6763 9.3824 10 12 10c2.2248 0 4.1668 1.2109 5.2029 3.0097A4.6 4.6 0 0 1 17.5 13c2.4853 0 4.5 2.0147 4.5 4.5S19.9853 22 17.5 22z"
    })
  }));
};
export default CloudSun03;